import api from './api';
import { API_KEYS } from '../configs/routes';

export const getApiKeys = (sortOptions) =>
    new Promise((resolve, reject) => {
        api.get(
            `${API_KEYS}?${new URLSearchParams({
                ...(sortOptions && { sort_field: sortOptions.field, sort_order: sortOptions.sort }),
            }).toString()}`
        )
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const createApiKey = (data) =>
    new Promise((resolve, reject) => {
        api.post(API_KEYS, data)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const updateApiKey = (id, data) =>
    new Promise((resolve, reject) => {
        api.put(`${API_KEYS}${id}/`, data)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });

export const deleteApiKey = (id) =>
    new Promise((resolve, reject) => {
        api.delete(`${API_KEYS}${id}/`)
            .then((response) => resolve(response.data))
            .catch((err) => reject(err.message));
    });
